import { gql } from "graphql-tag";

export const GET_LOCATION_DETAILS = gql`
  query GetLocationDetails($locationId: ID!) {
    locationDetails(locationId: $locationId) {
      location {
        id
        name
        categoryId
        category {
          id
          name
          color
        }
        accountId
        street
        zip
        city
        country
        phone
        isTemplate
        latitude
        longitude
        createdAt
        updatedAt
      }
      todayAppointments {
        id
        source
        kind
        startDate
        durationDisplay
        typeLabel
        title
        description
        contactDisplay
        linkPath
        isAllDay
        done
        eventTypeColor
        branchId
      }
      tomorrowAppointments {
        id
        source
        kind
        startDate
        durationDisplay
        typeLabel
        title
        description
        contactDisplay
        linkPath
        isAllDay
        done
        eventTypeColor
        branchId
      }
      activeTickets {
        id
        accountId
        locationId
        assetId
        title
        description
        status
        priority
        scheduledDate
        waitingSparePartsDate
        createdAt
        updatedAt
      }
      assets {
        id
        name
        description
        serial_number
        asset_number
        location_id
        createdAt
        updatedAt
      }
    }
  }
`;

export interface LocationDetailsAppointment {
  id: string;
  source: string;
  kind: string;
  startDate: string;
  durationDisplay?: string | null;
  typeLabel: string;
  title: string;
  description?: string | null;
  contactDisplay?: string | null;
  linkPath: string;
  isAllDay?: boolean | null;
  done?: boolean | null;
  eventTypeColor?: string | null;
  branchId?: string | null;
}

export interface LocationDetailsLocation {
  id: string;
  name: string;
  categoryId?: string | null;
  category?: { id: string; name: string; color?: string | null } | null;
  accountId?: string | null;
  street?: string | null;
  zip?: string | null;
  city?: string | null;
  country?: string | null;
  phone?: string | null;
  isTemplate?: boolean | null;
  latitude?: number | null;
  longitude?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface LocationDetailsTicket {
  id: string;
  accountId: string;
  locationId: string;
  assetId?: string | null;
  title: string;
  description: string;
  status: string;
  priority: string;
  scheduledDate?: string | null;
  waitingSparePartsDate?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface LocationDetailsAsset {
  id: string;
  name: string;
  description?: string | null;
  serial_number?: string | null;
  asset_number?: string | null;
  location_id?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface LocationDetailsPayload {
  location: LocationDetailsLocation;
  todayAppointments: LocationDetailsAppointment[];
  tomorrowAppointments: LocationDetailsAppointment[];
  activeTickets: LocationDetailsTicket[];
  assets: LocationDetailsAsset[];
}

export interface GetLocationDetailsResponse {
  locationDetails: LocationDetailsPayload | null;
}
